import React, { useContext, useRef, useLayoutEffect } from 'react';
import { WidthContext } from '../../WidthContext';
import './inlinePhotos.scss';
import { lang } from '../lang';

function InlinePhotos({ index }) {
  const { srcD, srcM } = lang.inline[index];
  const { viewSize } = useContext(WidthContext);
  const inline1Ref = useRef();
  const inline2Ref = useRef();
  const inline3Ref = useRef();
  const inline4Ref = useRef();
  const inline5Ref = useRef();
  const inline6Ref = useRef();
  const allRefs = useRef();
  allRefs.current = [
    inline1Ref,
    inline2Ref,
    inline3Ref,
    inline4Ref,
    inline4Ref,
    inline5Ref,
    inline6Ref
  ];

  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.3) {
            entry.target.style.animation = 'scale-down 0.5s linear forwards';
          }
        });
      },
      { threshold: [0, 0.3] }
    );
    allRefs.current.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });
  }, []);

  return (
    <figure className={`inline inline--${index}`}>
      <img
        className="inline__img"
        alt=""
        src={viewSize === 'large' ? srcD : srcM}
        ref={allRefs.current[index]}
      ></img>
    </figure>
  );
}

export default InlinePhotos;
